var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBolt = function SvgBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94 2.046a.75.75 0 0 0-1.185-.86l-6 5.25A.75.75 0 0 0 3.25 7.75h2.613l-1.802 4.205a.75.75 0 0 0 1.184.86l6-5.25a.75.75 0 0 0 .208-.827.75.75 0 0 0-.703-.485H8.137z"
  })));
};
export default SvgBolt;